import { render, staticRenderFns } from "./researchDynamics.vue?vue&type=template&id=d2b81cf4&scoped=true&"
import script from "./researchDynamics.vue?vue&type=script&lang=js&"
export * from "./researchDynamics.vue?vue&type=script&lang=js&"
import style0 from "./researchDynamics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./researchDynamics.vue?vue&type=style&index=1&id=d2b81cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b81cf4",
  null
  
)

export default component.exports